// extracted by mini-css-extract-plugin
export var backdropIn = "dialog-module--backdrop-in--4414b";
export var base = "dialog-module--base--ddfd1";
export var body = "dialog-module--body--7ba01";
export var container = "dialog-module--container--48e27";
export var dialogIn = "dialog-module--dialog-in--abc14";
export var footer = "dialog-module--footer--568ea";
export var header = "dialog-module--header--1ef0d";